// Source: app/scripts/controllers/edit-bti-case.js
Auction.controller('EditBTICaseController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  '$route',
  '$timeout',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  'ModalScrollLock',
  function ($scope, $filter, $routeParams, $location, $route, $timeout, toaster, crudService, $modal, Downloader, Messages, ModalScrollLock) {
  console.log('Edit BTI Case Controller');

    var caseService = crudService('cases', {
      'getCase': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/bti_cases/:id'
      },
      'editBTICase': {
        method: 'POST',
        url: '/data/rest/bti_cases/edit_bti_case'
      },
      'editBTI': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/bti/edit_bti'
      },
      'getPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/by_case_id/:id'
      },
      'getOutgoingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_outgoing_documents_for_case_id/:id'
      },
      'getIncomingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_incoming_documents_for_case_id/:id'
      },
      'editPortalDocumentMetadata': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_documents/edit_portal_document'
      },
      'deletePortalDocument': {
        method: 'DELETE',
        url: '/data/rest/portal_documents/:id'
      },
      'getForumMessagesForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/forum/get_forum_messages/:id'
      },
      'saveForumMessage': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/forum_messages'
      },
      'submitBTICase': {
        method: 'POST',
        url: '/data/rest/bti_cases/submit_bti_case'
      },
      'getBTIById': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/bti/by_bti_case_id/:id'
      },
      'getDocumentTypeByCode': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_document_types/by_code'
      }
    });

    // var movementCertificateGoodsService = crudService('movement_certificate_goods', {
    //   'getMovementCertificateGoodsForCaseId': {
    //     method: 'GET',
    //     isArray: true,
    //     url: '/data/rest/movement_certificate_goods/by_movement_certificate_case_id/:id'
    //   },
    //   'addMovementCertificateGoodToMovementCertificateCase': {
    //     method: 'POST',
    //     url: '/data/rest/movement_certificate_goods/add_movement_certificate_goods_to_movement_certificate_case'
    //   },
    //   'deleteMovementCertificateGood': {
    //     method: 'DELETE',
    //     url: '/data/rest/movement_certificate_goods/:id'
    //   },
    //   'saveMovementCertificateGoods': {
    //     method: 'POST',
    //     isArray: 'true',
    //     url: '/data/rest/movement_certificate_goods/save_goods'
    //   }
    // });

    // var movementCertificateInvoicesService = crudService('movement_certificate_invoices', {
    //   'getMovementCertificateInvoicesForCaseId': {
    //     method: 'GET',
    //     isArray: true,
    //     url: '/data/rest/movement_certificate_invoices/by_movement_certificate_case_id/:id'
    //   },
    //   'addMovementCertificateInvoiceToMovementCertificateCase': {
    //     method: 'POST',
    //     url: '/data/rest/movement_certificate_invoices/add_movement_certificate_invoices_to_movement_certificate_case'
    //   },
    //   'deleteMovementCertificateInvoice': {
    //     method: 'DELETE',
    //     url: '/data/rest/movement_certificate_invoices/:id'
    //   },
    //   'saveMovementCertificateInvoices': {
    //     method: 'POST',
    //     isArray: 'true',
    //     url: '/data/rest/movement_certificate_invoices/save_invoices'
    //   }
    // });


    var forumService = crudService('forum', {
        'getForumMessagesForCase': {
          method: 'GET',
          isArray: true,
          url: '/data/rest/forum/get_forum_messages/:id'
        },
        'saveForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        },
        'submitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages/submit_forum_message'
        },
        'deleteForumMessage': {
          method: 'DELETE',
          isArray: false,
          url: '/data/rest/forum_messages/:id'
        },
        'saveAndSubmitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        }

      }
    );
    if ($routeParams && $routeParams.recordsTab) {
      $scope.recordsTab = $routeParams.recordsTab;
    }

    $scope.activateTab = function (rt) {
      var search = {
        recordsTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsTab = rt;
      // $location.search(search);
    };


    if ($routeParams && $routeParams.recordsDocumentTab) {
      $scope.recordsDocumentTab = $routeParams.recordsDocumentTab;
    }

    $scope.activateDocumentTab = function (rt) {
      var search = {
        recordsDocumentTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsDocumentTab = rt;
      // $location.search(search);
    };


    function loadBTICaseData(caseId) {
      caseService.getBTIById({id: caseId}, function (data) {
        $scope.bti = data || {};
      });
    }

    function initEntity() {

      var portalCase;
      caseService.getCase({id: $routeParams.id}, function (data) {

        portalCase = data;
        if(portalCase.caseStatus != 'DRAFT' && portalCase.caseStatus != 'RETURNED_FOR_CORRECTIONS'){
          $scope.viewAuthorizationCase(portalCase.id);
        }
        $scope.allowEdit = true;
        $scope.entity = {};
        $scope.entity.portalCase = portalCase;
        $scope.forum = portalCase.forum;
        $scope.newForumMessage = {};
        $scope.authorizationTariff = {};
        $scope.foundAuthorizationTafiff = "";
        // $scope.movementCertificate = {};
        // $scope.movementCertificateGoods ={};
        // $scope.movementCertificateInvoices ={};
        $scope.bti = {};

        $scope.chosenDocument = {};
        $scope.portalDocument = {};
        if (portalCase.aboutIndividual) {
          $scope.entity.forCompany = 0;
          $scope.entity.forIndividual = 1;
          $scope.forCompany = 0;
          $scope.forIndividual = 1;
          $scope.individual = portalCase.aboutIndividual;
          console.log('$scope in edit');
          console.log($scope);
        } else {
          $scope.entity.forCompany = 1;
          $scope.entity.forIndividual = 0;
          $scope.forCompany = 1;
          $scope.forIndividual = 0;
          $scope.company = portalCase.aboutCompany;
          // $location.path("/web_portal/web_portal_home_page/create_general_case");
          console.log('$scope in edit');
          console.log($scope);
        }
        $scope.activateTab(1);
        loadBTICaseData($scope.entity.portalCase.id);
        caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
          $scope.outgoingDocumentList = data;
          $scope.activateDocumentTab(1);
          caseService.getIncomingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.incomingDocumentList = data;
            caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
              $scope.forumMessagesList = data;
            });
          });
        });
      });


    }


    initEntity();


    $scope.editCase = function (portalCase) {
      console.log('EDIT CASE', portalCase);
      caseService.editBTICase(portalCase, function (data) {
        $scope.entity.portalCase = portalCase;
        Messages.saved();
      })
    };


    $scope.downloadDocument = function () {
      if ($scope.chosenDocument.id) {
        Downloader.download('/data/rest/portal_attachments/get/' + $scope.chosenDocument.id);
      }
    };

    $scope.saveChosenDocumentMetadata = function () {
      if ($scope.chosenDocument.id) {
        caseService.editPortalDocumentMetadata(
          {
            id:  $scope.chosenDocument.id,
            description:  $scope.chosenDocument.description,
            typeId: $scope.chosenDocument.documentType.id
          }, function (data) {
            $scope.chosenDocument = data;
            Messages.saved();
          })
      }
    };


    $scope.outgoingDocumentsIndeks = -1;
    $scope.incomingDocumentsIndeks = -1;
    $scope.chooseOutgoingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.outgoingDocumentsIndeks = index;
      $scope.incomingDocumentsIndeks = -1;
    };
    $scope.chooseIncomingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.incomingDocumentsIndeks = index;
      $scope.outgoingDocumentsIndeks = -1;
    };


    $scope.modalAddOrEditBTIRequiredDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_bti_required_document.html',
      show: false
    });

    $scope.modalAddOrEditCaseDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_case_document.html',
      show: false
    });

    $scope.modalSubmitCaseConfirm = $modal({
      scope: $scope,
      // title: $filter('translate')('portal.forum'),
      template: 'templates/forum-form.tpl.html',
      contentTemplate: 'forms/modals/submit_case_confirm.html',
      show: false
    });



    $scope.showAddNewDocumentForm = function () {
      $scope.portalDocument = {};
      $scope.modalAddOrEditCaseDocument.show();
    };

    $scope.changeAttachmentForDocument = function () {
      if ($scope.chosenDocument.id) {
        $scope.portalDocument = $scope.chosenDocument;
        $scope.modalAddOrEditBTIRequiredDocument.show();
      }
    };

    $scope.savePortalDocument = function () {
      caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
        $scope.outgoingDocumentList = data;
      });
      $scope.modalAddOrEditCaseDocument.hide();

      $scope.portalDocument = {};

    };


    $scope.showAddNewBTIRequiredDocForm = function () {

        caseService.getDocumentTypeByCode({code: 'BTI_REQUIRED'}, function (data) {
          $scope.portalDocument = {};
          $scope.portalDocument.documentType = data;
          $scope.modalAddOrEditBTIRequiredDocument.show();
        });

    };


    $scope.deletePortalDocument = function () {
      if ($scope.chosenDocument.id) {
        caseService.deletePortalDocument({id: $scope.chosenDocument.id}, function () {
          caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.outgoingDocumentList = data;
            Messages.deleted();
            $scope.chosenDocument = {};
          });
        })
      }

    };

    $scope.saveForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      caseService.saveForumMessage(forumMessage, function (data) {
        caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })

    };


    $scope.submitForumMessage = function (forumMessage) {
      forumService.submitForumMessage(forumMessage.id, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };


    $scope.saveAndSubmitForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      forumService.saveForumMessage(forumMessage, function (data) {
        $scope.forumMessage2 = data;
        forumService.submitForumMessage(data.id, function (data) {
          forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
            $scope.forumMessagesList = data;
            $scope.newForumMessage = {};
          });
        });
      });
    };

    $scope.deleteForumMessage = function (forumMessage) {
      forumService.deleteForumMessage({id: forumMessage.id}, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };

    $scope.openSubmitForm = function(portalCase){
      $scope.portalCase = portalCase;
      $scope.modalSubmitCaseConfirm.show();
    };

    $scope.submitPortalCase = function (id) {

      caseService.submitBTICase(id, function (data) {
        Messages.saved();
        $scope.modalSubmitCaseConfirm.hide();
        ModalScrollLock.release();
        $location.path("/web_portal/web_portal_home_page/view_bti_case/" + id);
        $timeout(function () {
          ModalScrollLock.release();
          $route.reload();
        });
      });

    };

    // $scope.addMovementCertificateInvoices = function (movementCertificateInvoices) {
    //   movementCertificateInvoices.movementCertificateCase = $scope.movementCertificate.movementCertificateCase;
    //   $scope.movementCertificateInvoicesList.push(movementCertificateInvoices);
    //   $scope.movementCertificateInvoices = {};
    // };
    //
    // $scope.removeMovementCertificateInvoices = function (item) {
    //   var index = item;
    //   $scope.movementCertificateInvoicesList.splice(index, 1);
    // };
    //
    // $scope.addMovementCertificateGoods = function (movementCertificateGoods) {
    //   var counter = $scope.movementCertificateGoodsList.length;
    //
    //   if(movementCertificateGoods.itemNumber){
    //     $scope.movementCertificateGoodsList.splice(movementCertificateGoods.itemNumber-1, 1);
    //
    //   }else{
    //     movementCertificateGoods.itemNumber = $scope.movementCertificateGoodsList.length+1;
    //   }
    //
    //   $scope.movementCertificateGoodsList.splice(movementCertificateGoods.itemNumber-1, 0, movementCertificateGoods);
    //   $scope.movementCertificateGoods = {};
    // };
    //
    // $scope.removeMovementCertificateGoods = function (item) {
    //   var index = item;
    //   $scope.movementCertificateGoodsList.splice(index, 1);
    //   if(index < $scope.movementCertificateGoodsList.length){
    //     var i = index;
    //     while(i<$scope.movementCertificateGoodsList.length){
    //       $scope.movementCertificateGoodsList[i].itemNumber = i+1;
    //       i++;
    //
    //     }
    //   }
    //
    // };

    // $scope.editMovementCertificateGoods = function (item) {
    //   var index = item;
    //   $scope.movementCertificateGoods = $scope.movementCertificateGoodsList[index];
    //   // $scope.movementCertificateCaseEntity.movementCertificateGoodsList.splice(index, 1);
    //   // for (i = 0; i < $scope.movementCertificateCaseEntity.movementCertificateGoodsList; i++) {
    //   //   $scope.movementCertificateCaseEntity.movementCertificateGoodsList[i].itemNumber = i+1;
    //   // }
    // };

    $scope.editBTI = function (bti) {
      console.log('EDIT BTI', bti);
      $scope.entityForUpdate = {};
      $scope.entityForUpdate.bti = {};
      // $scope.entityForUpdate.movementCertificateGoodsList = [];
      // $scope.entityForUpdate.movementCertificateInvoicesList = [];

      $scope.entityForUpdate.bti = bti;
      // $scope.entityForUpdate.movementCertificateGoodsList = movementCertificateGoodsList;
      // $scope.entityForUpdate.movementCertificateInvoicesList = movementCertificateInvoicesList;

      caseService.editBTI($scope.entityForUpdate.bti, function (data) {
        $scope.bti = data;
        Messages.saved();
        $scope.activateTab(1);
      });
      // console.log('tuka sme');
      // $location.path("/web_portal/web_portal_home_page/edit_bti_case/" + data.id);
      // caseService.editMovementCertificate(movementCertificate, function (data) {
      //   $scope.movementCertificate = data;
      // });
      // movementCertificateGoodsService.saveMovementCertificateGoods(movementCertificateGoodsList, function(goods){
      //   $scope.movementCertificateGoodsList = goods;
      // });
      // movementCertificateInvoicesService.saveMovementCertificateInvoices(movementCertificateInvoicesList, function(invoices){
      //   $scope.movementCertificateInvoicesList = invoices;
      //   Messages.saved();
      // });
    };

    $scope.viewBTICase = function (id) {
      $location.path("/web_portal/web_portal_home_page/view_bti_case/" + id);
    };


  }
]);
